<template>
  <v-card :width="$isMobile ? (windowInnerWidth * 0.98) - 20 : 734" elevation="2" class="mx-auto" outlined
          :style='$isMobile ? "background: #F8F5FD":"background: #f3f4f6"'>
    <div class="pa-2 rounded">
      <v-img
        :src="require('chinese' === currentLanguage ? '@/assets/images/itsm-banner.png' : '@/assets/images/incident-ticket-banner.png')"></v-img>
    </div>
    <v-card-text>
      <v-form ref="ticketForm" v-model="valid">
        <div class="mb-4">
          <div class="label mb-1">
            {{ 'chinese' === currentLanguage ? '标题' : 'Title' }}
          </div>
          <v-text-field
            v-model="curTitle"
            style="background: #fff"
            outlined
            :rules="[v=> !!v]"
            dense
            :disabled="disabled"
            hide-details
          ></v-text-field>
        </div>
        <div class="label mb-1">
          {{ 'chinese' === currentLanguage ? '描述' : 'Description' }}
        </div>
        <v-textarea
          outlined
          style="background: #fff"
          name="input-7-4"
          rows="5"
          dense
          :rules="[v=> !!v]"
          :disabled="disabled"
          hide-details
          auto-grow
          v-model="description"
        ></v-textarea>
      </v-form>
    </v-card-text>
    <v-card-actions :class="$isMobile ? 'd-flex justify-center':''">
      <v-spacer v-if="!$isMobile"></v-spacer>
      <v-btn v-if="$isMobile" class="mt-2 rounded-pill" style="background: #A75CFF !important;"
             :loading="submitLoading" :disabled="disabled" @click="submitTicket">
        <span style="color: #FFFFFF" class="mx-6">{{ currentLanguage === 'chinese' ? '确认提交' : 'Submit' }}</span>
      </v-btn>
      <v-btn v-else class="mt-2" color="primary" style="background: linear-gradient(345.84deg, #f4e3ff 0%, #fdf 100%);"
             :loading="submitLoading" :disabled="disabled" @click="submitTicket">
        <span style="color: #7F27D3">{{ currentLanguage === 'chinese' ? '确认提交' : 'Submit' }}</span>
      </v-btn>
    </v-card-actions>
  </v-card>
</template>
<script>
import { createItTicket } from '../../../../api/index'

export default {
  props: {
    language: {
      type: String,
      default: 'chinese',
    },
    submitDisabled: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: '',
    },
    desc: {
      type: String,
      default: '',
    },
  },
  watch: {
    submitDisabled: {
      handler(newVal) {
        this.disabled = newVal
      },
      immediate: true,
    },
    desc: {
      handler(newVal) {
        this.description = newVal
      },
      immediate: true,
    },
  },
  computed: {
    windowInnerWidth() {
      return window.innerWidth
    },
  },
  data() {
    return {
      submitLoading: false,
      description: '',
      curTitle: '',
      disabled: false,
      currentLanguage: 'chinese',
      valid: true,
    }
  },
  mounted() {
    this.currentLanguage = this.language
    this.curTitle = this.title
  },
  methods: {
    async submitTicket() {
      if (!this.$refs.ticketForm.validate()) {
        return
      }
      this.submitLoading = true
      const { data: { code, data } } = await createItTicket({
        title: this.curTitle,
        description: this.description,
      })
      if (code === 200) {
        this.disabled = true
        this.$bus.$emit('addMessage', {
          type: 'ticketCreateSuccess',
          title: this.curTitle,
          description: this.description,
          language: this.currentLanguage,
          ...data,
        })
      } else {
      this.$bus.$emit('addMessage', {
        type: 'ticketCreateError',
        title: this.curTitle,
        description: this.description,
        language: this.currentLanguage,
      })
      }
      this.submitLoading = false
    },
  },
}
</script>
<style lang='scss' scoped>
.label {
  color: #000000de;
  font-size: 14px;
  font-weight: 500;
}
</style>
